var React = require('react');

function IconTitan (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M512 570.5c-32.7 0-59.3-26.5-59.3-59.3V215.3c-175.2 10.4-316.2 157.8-316.2 335.4 0 184.2 151.7 336 335.9 336 177.6 0 325-141 335.4-316.2H512zm0-39.6h316.2c10.9 0 19.8 8.8 19.8 19.8 0 206.1-169.4 375.5-375.5 375.5S97 756.8 97 550.7s169.4-375.5 375.5-375.5c10.9 0 19.8 8.8 19.8 19.8v316.2c-.1 10.9 8.8 19.7 19.7 19.7z","key":0}),React.createElement("path",{"d":"M571.3 432.1c0 10.9 8.8 19.8 19.8 19.8h295.8c-4.8-81.9-39.5-159.5-97.8-217.8-58.3-58.3-135.9-93-217.8-97.8v295.8zm-39.5 0V115.9c0-10.9 8.8-19.8 19.8-19.8 99.5 0 195.1 39.6 265.5 110s110 166 110 265.5c0 10.9-8.8 19.8-19.8 19.8H591c-32.7 0-59.2-26.5-59.2-59.3z","key":1})]);
}

IconTitan.displayName = "IconTitan";

IconTitan.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconTitan;

IconTitan.default = IconTitan;
